import { render } from "./CreateTaskSection.vue?vue&type=template&id=70d4054d&ts=true"
import script from "./CreateTaskSection.vue?vue&type=script&lang=ts"
export * from "./CreateTaskSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__